import { DocumentRequirement } from '../DocumentRequirement/DocumentRequirement';

// Using other documents on DE will trigger manual review
export const OtherDocuments = () => {
  return (
    <DocumentRequirement
      title="Other documents "
      documentType="other"
      isOptional
    >
      <p>
        In this section you can upload any other supporting information that may
        help us with our review. This could include documents such as proposal
        forms, tender forms, contracts, due invoices, share purchase agreements,
        and tax bills.
      </p>
    </DocumentRequirement>
  );
};
